import clsx from 'clsx'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import { useMemo } from 'react'
import TalentProfile from '../../../components/discover/aivy-pdf-reports/components/talentProfile'
import { Heading } from '../../../components/ui/Heading'
import {
  useLanguageContext,
  useNotificationContext,
  useUserContext
} from '../../../context'
import { useDiscover } from '../hooks/useDiscover'
import { useTalentProfileDownload } from '../hooks/useTalentProfileDownload'
import { getProfileOptions } from '../utils'
import EnableFlexSwitch from './EnableFlexSwitch'
import PrintButton from './PrintButton'
import ProfileDropdown from './ProfileDropdown'

export default function TalentProfileSection({
  talent,
  career,
  talentProfile,
  className = '',
  isLoading
}) {
  const { t } = useTranslation()
  const {
    selectedResult,
    setSelectedResult,
    isFlexibleMatchingEnabled,
    setIsFlexibleMatchingEnabled
  } = useDiscover()
  const { success, error } = useNotificationContext()
  const { language } = useLanguageContext()
  const { activeSpace } = useUserContext()
  const hasCompletedOnboarding = activeSpace?.hasCompletedOnboarding

  const profileOptions = useMemo(() => getProfileOptions(t), [t])

  const handleDownloadReport = useTalentProfileDownload({
    talentOwner: talent?.owner,
    spaceId: talent?.id,
    language,
    t,
    onSuccess: success,
    onError: error
  })

  return (
    <div className={clsx('w-full rounded-lg bg-white py-6', className)}>
      {isLoading && (
        <div className='mb-4 flex justify-center'>
          <span className='text-sm text-darkBlack'>
            {t('discover.talent_report.isLoading')}
          </span>
        </div>
      )}
      <div className='border-b border-lightGrey px-6 pb-6'>
        <div className='flex flex-row items-start justify-between'>
          <div>
            <Heading level={6} className={'text-primaryBlue'}>
              {isLoading ? (
                <Skeleton />
              ) : (
                t('discover.talent_match_section.title')
              )}
            </Heading>
            <ProfileDropdown
              className='mt-1'
              selectedProfile={selectedResult}
              profileOptions={profileOptions}
              onProfileChange={setSelectedResult}
              isLoading={isLoading}
            />
          </div>
          <EnableFlexSwitch
            enabled={isFlexibleMatchingEnabled}
            setEnabled={setIsFlexibleMatchingEnabled}
            isLoading={isLoading}
          />
        </div>
        {/* {canRenderInfoCards && (
          <InfoCardPair career={career} talent={talent} isLoading={isLoading} />
        )} */}
      </div>
      <div className='relative mt-8'>
        <TalentProfile
          data={talentProfile}
          withoutAttachments
          isLoading={isLoading}
          hasCompletedOnboarding={hasCompletedOnboarding}
        />
        <div className='mt-6 px-6'>
          <PrintButton
            onClick={handleDownloadReport}
            text={t('discover.talent_match_section.print_button')}
            isLoading={isLoading}
          />
        </div>
      </div>
    </div>
  )
}

TalentProfileSection.propTypes = {
  talent: PropTypes.shape({
    id: PropTypes.string,
    owner: PropTypes.string
  }),
  career: PropTypes.object,
  talentProfile: PropTypes.object,
  className: PropTypes.string,
  isLoading: PropTypes.bool
}
